import { render } from "./Messages.vue?vue&type=template&id=54a2ed9e&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=54a2ed9e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a2ed9e"]])

export default __exports__